import type { IOption } from "@/interfaces";
import { EmptyOption } from "@/interfaces";
import type { IShapeOfField } from "@/utils/zod";
import { emptyStringToUndefined, z } from "@/utils/zod";

export interface IEnterInformationFormSchema {
  firstName: string;
  lastName: string;
  studentGender: IOption;
  emailAddress: string;
  studentDegree: IOption;
  password: string;
  confirmPassword: string;
}

export const enterInformationFormInitialValues: IEnterInformationFormSchema = {
  firstName: "",
  lastName: "",
  studentGender: EmptyOption,
  emailAddress: "",
  studentDegree: EmptyOption,
  password: "",
  confirmPassword: "",
};

export const enterInformationFormValidationSchema = z
  .object<IShapeOfField<IEnterInformationFormSchema>>({
    firstName: emptyStringToUndefined(z.string()),
    lastName: emptyStringToUndefined(z.string()),
    studentGender: z.dropdown(),
    emailAddress: emptyStringToUndefined(z.string().email().optional()),
    studentDegree: z.dropdown(true),
    password: z.string().min(8),
    confirmPassword: z.string().min(8),
  })
  .superRefine((values, ctx) => {
    const password = values.password as string;

    if (!/[A-Z]/.test(password)) {
      ctx.addIssue({
        code: "custom",
        path: ["password"],
        params: { i18n: "changePasswordFormError.upperCase" },
      });
    }

    if (!/\d/.test(password)) {
      ctx.addIssue({
        code: "custom",
        path: ["password"],
        params: { i18n: "changePasswordFormError.number" },
      });
    }

    if (values.password !== values.confirmPassword) {
      ctx.addIssue({
        code: "custom",
        path: ["confirmPassword"],
        params: { i18n: "changePasswordFormError.match" },
      });
    }
  });
